module.exports = __webpack_public_path__ + "img/poster-dezyr-teaser2.eb1deb51.jpg";